import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.customers")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="Customers"
      description="Customer accounts."
      table="profiles"
      columns={[
        { key: "full_name", label: "Name" },
        { key: "phone", label: "Phone" },
        { key: "role", label: "Role" },
      ]}
    />
  );
}